import { useLayoutElementsResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsResponse";
import {
  isValidForPage,
  isValidForPlatform,
} from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/utils/layoutElementFilterUtils";
import { useOneIndexedPageNumber } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { useMemo } from "react";

const TOP_OF_PAGE_PLACEMENTS = [
  ILayoutElement.Placement.BELOW_BREADCRUMB,
  ILayoutElement.Placement.ABOVE_TITLE,
  ILayoutElement.Placement.BELOW_TITLE,
  ILayoutElement.Placement.TOP,
];

export const useTopOfPageLayoutElements = () => {
  const { data } = useLayoutElementsResponse();
  const { isMobile } = useViewport();
  const pageNumber = useOneIndexedPageNumber();
  const layoutElements = useMemo(() => data?.layout_elements ?? [], [data]);

  return useMemo(
    () =>
      layoutElements
        .filter(
          (layoutElement) =>
            layoutElement.placement &&
            TOP_OF_PAGE_PLACEMENTS.includes(
              layoutElement.placement as ILayoutElement.Placement
            )
        )
        .filter(
          (layoutElement) =>
            isValidForPlatform(layoutElement, isMobile) &&
            isValidForPage(layoutElement, pageNumber)
        ),
    [layoutElements, isMobile, pageNumber]
  );
};
